import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getRainTickers,
  putRainTicker,
  putRainTickers,
  type PutRainTickerRequestType,
  type PutRainTickersRequestType,
} from 'features/Location/services/hubWeather'
import {
  setIsLoading,
  setRainTickers,
  setLastUpdatedRainTickers,
} from 'features/Location/redux/hubWeather'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastFailed, toastSuccess } from 'utils/toast'
import { SLICE_NAME } from './slice'

export const fetchRainTicker = createAsyncThunk(
  `${SLICE_NAME}/fetchRainTicker`,
  async (_, { dispatch, getState }) => {
    const {
      hubWeather: { query },
    } = getState() as StoreStateType

    dispatch(setIsLoading(true))
    try {
      const { data } = await getRainTickers({
        params: { search: '', status: query.status },
      })

      if (data.error?.status) {
        toastFailed(data.error.message)
      } else {
        dispatch(setLastUpdatedRainTickers(data.data.updated_at))
        dispatch(
          setRainTickers(
            data.data.locations.map((el) => ({
              ...el,
              uniqueID: window.crypto.randomUUID(),
              isChecked: false,
            })),
          ),
        )
      }
    } catch (err) {
      callErrorMsg(err)
    }
    dispatch(setIsLoading(false))
  },
)

export const updateRainTicker = createAsyncThunk(
  `${SLICE_NAME}/updateRainTicker`,
  async ({ data, id }: PutRainTickerRequestType, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))
    try {
      const { data: resData } = await putRainTicker({
        id,
        data,
      })

      if (resData.error?.status) {
        toastFailed(resData.error.message)
      } else {
        toastSuccess(resData.data.message)
      }
      dispatch(setIsLoading(false))

      return resData
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))
      return rejectWithValue(err)
    }
  },
)

export const updateRainTickers = createAsyncThunk(
  `${SLICE_NAME}/updateRainTickers`,
  async ({ data }: PutRainTickersRequestType, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))
    try {
      const { data: resData } = await putRainTickers({
        data,
      })

      if (resData.error?.status) {
        toastFailed(resData.error.message)
      } else {
        toastSuccess(resData.data.message)
      }
      dispatch(setIsLoading(false))

      return resData
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))

      return rejectWithValue(err)
    }
  },
)
